export { default } from './LazySecurityPrivacyPolicy';
